import http from "@/utils/http";
let hr = "/hrApi";
// let host = "/oaApi/nvc/public";
// // let qrcode = "/qrcodeApi";
// let config = "http://qrcode.nvc-lighting.com.cn";

export default {
  queryByPage: (data) => http.post(`${hr}/payslip/queryByPage`, data), // 列表
  queryUnitList: (data) => http.post(`${hr}/payslip/queryUnitList`, data), // 下拉框
  // 下载模板
  downTemplate: () =>
    http.get(`${hr}/payslip/downTemplate`, {
      responseType: "blob",
    }),
  // 导入
  importExcel: (data) =>
    http.post(`${hr}/payslip/importExcel`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }),

  // 导出
  excelReport: (data) =>
    http.post(`${hr}/payslip/excelReport`, data, {
      responseType: "blob",
    }),
};
